import {
  firstDateOfMonth, last2, last60, today,
} from '@/store/helpers'
import { LABELDAY, LABELMONTH } from '@/libs/formatDate'

export const statusTicket = [
  {
    label: 'Menunggu Tindak Lanjut',
    value: 0,
    onCheck: false,
  },
  {
    label: 'Perlu Diproses',
    value: 1,
    onCheck: false,
  },
  {
    label: 'Sedang Diproses',
    value: 2,
    onCheck: false,
  },
  {
    label: 'Selesai',
    value: 3,
    onCheck: false,
  },
]

export const fieldResponMassal = [
  {
    key: 'uploaded_date',
    label: '',
  },
  {
    key: 'partner_name',
    label: '',
  },
  {
    key: 'ticket_analysis_results.total',
    label: 'Total',
  },
  {
    key: 'ticket_analysis_results.appropriate',
    label: 'Sesuai',
  },
  {
    key: 'ticket_analysis_results.not_appropriate',
    label: 'Belum Sesuai',
  },
  {
    key: 'update_status_ticket.succeed',
    label: 'Berhasil',
  },
  {
    key: 'update_status_ticket.fail_implement',
    label: 'Gagal Menerapkan',
  },
  {
    key: 'update_status_ticket.fail_adjust',
    label: 'Gagal Menyesuaikan',
  },
  {
    key: 'action',
    label: '',
  },
]

export const fieldsFailedTicket = [
  {
    key: 'ticket_no',
    label: 'No. Tiket',
    formatter: value => value || '-',
  },
  {
    key: 'no_resi',
    label: 'Nomor Resi',
    formatter: value => value || '-',
  },
]

export const rangeDate = {
  startDate: today,
  endDate: today,
}
export const locale = {
  applyLabel: 'Pilih',
  cancelLabel: 'Batal',
  format: 'dd/mm/yyyy',
  daysOfWeek: LABELDAY,
  monthNames: LABELMONTH,
}
export const ranges = {
  'Hari Ini': [today, today],
  Kemarin: [last2, last2],
  'Bulan Ini': [firstDateOfMonth, today],
  'Custom Range': [last60, today],
}
